import { ContractDocumentDto, ContractDocumentSearchRequest, UpsertContractDocumentDto } from 'ts-types/api.types';
import axios from './http';
import { CancelTokenSource } from 'axios';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/contract`;

export const searchContractDocuments = (contractDocumentSearchRequest: Partial<ContractDocumentSearchRequest>,
                                        source: CancelTokenSource): Promise<Array<ContractDocumentDto>> => {
  return axios
      .post(`${apiUri}/search`, contractDocumentSearchRequest, {cancelToken: source.token})
      .then(response => response.data)
}

export const findContractDocumentsById = (id: number, source: CancelTokenSource): Promise<UpsertContractDocumentDto> => {
  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
}

export const saveContractDocument = (upsertContractDocumentDto: Partial<UpsertContractDocumentDto>,
                                     source: CancelTokenSource): Promise<UpsertContractDocumentDto> => {
  return axios
      .post(`${apiUri}/add`, upsertContractDocumentDto, {cancelToken: source.token})
      .then(response => response.data);
}

export const editContractDocument = (id: number, upsertContractDocumentDto: Partial<UpsertContractDocumentDto>,
                                     source: CancelTokenSource): Promise<ContractDocumentDto> => {
  return axios
      .put(`${apiUri}/${id}`, upsertContractDocumentDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const deleteContractDocument = (id: number, source: CancelTokenSource): Promise<ContractDocumentDto> => {
  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
}
